import styled from 'styled-components';
import {
  tablet_landscape_breakpoint,
  tablet_portrait_breakpoint,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths';
import Colors from 'pubweb-smokey/dist/colors';

export const MultiStatePrivacyStyles = styled.div`
  padding: 0 20px;

  .multi-state-privacy-content {
    margin-top: 50px;
    @media screen and (min-width: ${tablet_landscape_breakpoint}px) {
      margin: 0 auto;
      max-width: 996px;
      padding-top: 85px;
    }
    h1,
    h3 {
      font-family: 'acumin-pro', sans-serif;
      margin: 20px auto 10px;
      text-transform: uppercase;
    }
    p {
      color: #4e5255;
      font-family: 'source-sans-pro', sans-serif;
      font-size: 14px;
      line-height: 1.15;
      margin-bottom: 10px;
    }
    h1 {
      font-size: 36px;
      letter-spacing: -0.3px;
      line-height: 1.18;
      @media screen and (min-width: ${tablet_portrait_breakpoint}px) {
        font-size: 40px;
        letter-spacing: 0.35px;
        line-height: 1.2;
      }
    }
    h5 {
      font-family: 'source-sans-pro', sans-serif;
      font-size: 16px;
      /* font-style: italic; */
      font-weight: normal;
      letter-spacing: -0.3px;
      line-height: 1.25;
      margin: 20px auto 10px;
      text-decoration: underline;
    }

    .divider-line {
      margin: 20px 0;
      border-top: 2px solid ${Colors.accent.grey3.standard};
    }
    .box-header {
      border: 1px solid black;
      padding: 5px;

      text-align: center;
      margin: 20px 0;
      font-family: 'source-sans-pro', Helvetica, Arial, sans-serif;
      font-weight: bold;
    }
    .centered-header {
      text-align: center;
      text-decoration: underline;
      margin-top: 20px;
      margin-bottom: 15px;
      font-family: 'source-sans-pro', Helvetica, Arial, sans-serif;
      font-weight: bold;
    }
    .page-heading {
      text-align: center;
      margin-top: 20px;
      margin-bottom: 15px;
    }
    ul {
      padding-left: 20px;
    }
    li {
      color: #4e5255;
      font-family: 'source-sans-pro', sans-serif;
      font-size: 14px;
      line-height: 1.15;
      margin-bottom: 10px;
    }
    table,
    th,
    td {
      border: 1px solid black;
      border-collapse: collapse;
    }
    table {
      margin-bottom: 10px;
      tr {
        td {
          padding: 10px 10px 0;
          vertical-align: top;
        }
      }
    }

    @media screen and (max-width: ${tablet_portrait_breakpoint}px) {
      .responsive-table {
        table,
        td,
        th {
          display: block;
          border: none;
          float: left;
        }
        table {
          width: 100%;
          border-bottom: 1px solid #cecece;
          margin-bottom: 25px;
          tr {
            display: flex;
            flex-direction: column;
          }

          td {
            text-align: left;
          }
        }
        .table-1-col-2-heading,
        .table-1-col-3-heading,
        .table-2-col-2-heading,
        .table-2-col-3-heading {
          display: none;
        }
        .table-1-col-1-heading,
        .table-2-col-1-heading {
          text-align: center;
        }
        .table-1-col-3-content,
        .table-2-col-3-content {
          border-bottom: 1px solid #bdbdbd;
          margin-bottom: 10px;
        }

        .table-1-col-2-content,
        .table-2-col-2-content {
          ul {
            padding-bottom: 10px;
            li:first-of-type {
              padding-top: 15px;
            }
            &:before {
              content: 'Purposes for Collection and Use';
              display: flex;
              font-weight: bold;
              justify-content: center;
              letter-spacing: -0.3px;
              line-height: 1.22;
            }
          }
        }
        .month-heading,
        .collected-heading,
        .disclosed-heading,
        .disclosure-heading,
        .third-party-heading {
          display: none;
        }
        .collected-content {
          padding-left: 150px;
          &:before {
            content: 'Collected';
            font-size: 14px;
            font-weight: 700;
            position: absolute;
            left: 30px;
            margin-top: -2px;
          }
        }
        .disclosed-content {
          border-bottom: 1px solid #bdbdbd;
          padding-left: 150px;
          &:before {
            content: 'Disclosed';
            font-size: 14px;
            font-weight: 700;
            position: absolute;
            left: 30px;
            margin-top: -2px;
          }
        }
        .disclosure-content {
          ul {
            border-bottom: 1px solid #bdbdbd;
            li:first-of-type {
              padding-top: 15px;
            }
          }
          &:before {
            content: 'Business or Commercial Purpose for Collection & Disclosure';
            display: flex;
            font-family: 'acumin-pro', sans-serif;
            font-size: 14px;
            font-weight: bold;
            justify-content: center;
            letter-spacing: -0.3px;
            line-height: 1.22;
            text-align: center;
          }
        }
        .third-party-content {
          ul {
            li:first-of-type {
              padding-top: 15px;
            }
          }
          &:before {
            content: 'Categories of third parties to whom the information was disclosed';
            display: flex;
            font-family: 'acumin-pro', sans-serif;
            font-size: 14px;
            font-weight: bold;
            justify-content: center;
            letter-spacing: -0.3px;
            line-height: 1.22;
            text-align: center;
          }
        }
      }
    }
  }
`;
export default MultiStatePrivacyStyles;
